import React, { FC } from 'react';

interface IfProps {
  condition: boolean;
  children?: React.ReactNode;
  render?: () => React.ReactNode;
}

/** @deprecated Use conditional rendering (`condition && <X />`) instead. */
export const If: FC<IfProps> = ({ condition, children, render }) => {
  return condition ? (render ? render() : children) : null;
};
